import { get, post, put } from './rest'
import OSS from 'ali-oss'
const TARGET = require('../../src/utils/target')
// 微信congif
export function getWxConfig (isShare = false, shareParams = {}) {
  return new Promise((resolve, reject) => {
    let para = {
      // url: location.origin + location.pathname + location.search
      url: encodeURIComponent(location.href)
    }
    let callback = (res) => {
      var wx = window.wx
      if (!res) {
        return
      }
      wx.config({
        beta: true, // 必须这么写，否则 wx.invoke 无法调用
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.appId, // 必填，公众号的唯一标识
        timestamp: res.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.nonceStr, // 必填，生成签名的随机串
        signature: res.signature, // 必填，签名，见附录1
        // jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        jsApiList: ['chooseWXPay', 'getLocation',
          'updateAppMessageShareData', 'updateTimelineShareData'
        ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        openTagList: ['wx-open-launch-weapp']
      })
      if (isShare) {
        wx.ready(function () { // 需在用户可能点击分享按钮前就先调用
          // 获取当前页URL并处理
          // var shareUrl = window.location.href.split('#')[0]
          // 含中文时需编码
          // shareUrl = encodeURIComponent(shareUrl)
          wx.updateTimelineShareData({
            title: shareParams.title, // 分享标题
            desc: shareParams.desc,
            // link: window.location.href.split('#')[0], // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            link: TARGET.INDEX, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareParams.imgUrl, // 分享图标，卡片右侧的图标
            success: function () {
              // 设置成功
              console.log('updateTimelineShareData 朋友圈 success==>')
            }
          })
          wx.updateAppMessageShareData({
            title: shareParams.title, // 分享标题
            desc: shareParams.desc,
            // link: window.location.href.split('#')[0], // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            link: TARGET.INDEX, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareParams.imgUrl, // 分享图标，卡片右侧的图标
            success: function () {
              // 设置成功
              console.log('onMenuShareTimeline 朋友圈 success==>')
            }
          })
          wx.error(function (res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            console.log('验证失败返回的信息:', res)
            location.reload()
          })
        })
      }
      resolve()
    }
    let errorback = (res) => {
      reject(res)
    }
    getConfig(para, callback, errorback)
  })
}
// 获取微信Config
export function getConfig (para, callback = null, errorback) {
  get('/weChat/api/config', para).then((res) => {
    if (!res) {
      console.log('服务器错误')
      return
    }
    if (callback) {
      callback(res)
    }
  }).catch(e => {
    console.log(e)
  })
}
// 图片上传
export function upload (para, callback = null) {
  get('/weChat/api/biz/ossConfig').then(res => {
    const {accessKeyId, accessKeySecret, bucketName, regionId, securityToken} = res
    const client = new OSS({
      accessKeyId,
      accessKeySecret,
      secure: true,
      stsToken: securityToken,
      bucket: bucketName,
      region: regionId
    })
    client.put(`/qmPic/m-${Date.now() + Math.random().toString(36).slice(-6) + para.image.name}`, para.image).then((r) => {
      console.log(r)
      if (callback) {
        callback(r)
      }
    }).catch(e => {
      console.log(e)
    })
  }
  ).catch(e => {
    console.log(e)
  })
}
// 人员信息提交
export function formCommit (params) {
  return put('/weChat/api/anniv/wechatUser', params)
}
// 获取微信信息
export function weixinInfo () {
  return get('/weChat/api/anniv/wechatUser/lastPoint')
}
// 再次点亮城市
export function lightCity (params) {
  return post('/weChat/api/anniv/wechatUserLight', params)
}
// 获取点亮的所有位置
export function lightPoints () {
  return get('/weChat/api/anniv/wechatUserLight/points')
}
// 微信配置信息
export function weixinConfig (params) {
  return post('/weChat/api/anniv/pay/preClientPay', params)
}
// 判断是否支付成功
export function isSuccessPay (params) {
  return get('/weChat/api/anniv/pay/checkState', params)
}
// 个人信息获取
export function personalInfo () {
  return get('/weChat/api/anniv/wechatUser')
}
// 个人信息提交
export function editPersonal (params) {
  return post('/weChat/api/biz/massSetVil', params)
}
// 获取我的单独捐
export function donationInfo () {
  return get('/weChat/api/anniv/donation', {page: 1, limit: 100})
}
// 获取单独捐news
export function donationNews () {
  return get('/weChat/api/anniv/donation/news')
}
// 获取单独捐news
export function auth (params) {
  return post('/weChat/api/auth', params)
}
// 获取点亮顺序和次数
export function lightSequence (params) {
  return get('/weChat/api/anniv/wechatUserLight/sequence', params)
}



// WEBPACK FOOTER //
// ./src/utils/ajaxInterface.js